import {
  Input,
  Form,
  Button,
  DatePicker,
  TimePicker,
} from "antd";
import {
  createElement,
  Component,
  Fragment,
  Props as ReactProps,
  FormEvent,
} from "react";
import locale from 'antd/es/date-picker/locale/ja_JP';
import localeTimepicker from 'antd/es/time-picker/locale/ja_JP';
import Order from "../../../../entity/order";
import { FormComponentProps } from "antd/lib/form";
import * as moment from 'moment';
import Store from "../../../../entity/store";
import validShipDate from "../../../../validator/order";
import PaymentCard from "./PaymentCard";

const { TextArea } = Input;

type Props = ReactProps<HTMLSpanElement> & {
  order: Order;
  store: Store;
  updateOrderField: (order: Partial<Order>) => void;
  onClickSave: () => void;
  isSaving: boolean;
};
type State = {
  validShipDate: boolean;
  validShipDateMsg: string | null;
};

class PaymentOnlyTakeout extends Component<Props & FormComponentProps, State> {
  constructor(props: Props & FormComponentProps) {
    super(props);

    this.state = {
      validShipDateMsg: null,
      validShipDate: true,
    };

    this.save = this.save.bind(this);
    this.updateShipDateTime = this.updateShipDateTime.bind(this);
    this.updateShipDate = this.updateShipDate.bind(this);
    this.disableDate = this.disableDate.bind(this);
    this.disableHours = this.disableHours.bind(this);
    this.disableMinutes = this.disableMinutes.bind(this);
    this.disableSubmit = this.disableSubmit.bind(this);
  }

  public render() {
    const {
      order,
      store,
      updateOrderField,
    } = this.props;
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };
    const styleFormItem = {
      style: {
        marginBottom: 14,
      },
    };

    return (
      <Fragment>
        <Form {...formItemLayout}  onSubmit={this.save}>
          <Form.Item {...styleFormItem} label="お名前">
            {getFieldDecorator('shipName', {
              rules: [
                {
                  required: true,
                  message: 'お名前は必須です。',
                },
              ],
              initialValue: order.shipName,
            })(
              <Input
                onChange={(e) => updateOrderField({ shipName: e.target.value })}
              />
            )}
          </Form.Item>
          <Form.Item {...styleFormItem} label="ふりがな">
            {getFieldDecorator('phonetic', {
              rules: [
                {
                  required: true,
                  message: 'ふりがなは必須です。',
                },
              ],
              initialValue: order.phonetic,
            })(
              <Input
                onChange={(e) => updateOrderField({ phonetic: e.target.value })}
              />
            )}
          </Form.Item>
          <Form.Item {...styleFormItem} label="電話番号">
            {getFieldDecorator('phone', {
              rules: [
                {
                  required: true,
                  message: '電話番号は必須です。',
                },
              ],
              initialValue: order.phone,
            })(
              <Input
                onChange={(e) => updateOrderField({ phone: e.target.value })}
                placeholder="ハイフン無し"
                pattern="\d*"
                maxLength={11}
              />
            )}
          </Form.Item>
          <Form.Item {...styleFormItem} label="メールアドレス">
            {getFieldDecorator('email', {
              rules: [
                {
                  type: 'email',
                  message: 'メールアドレスを入力してください。',
                },
                {
                  required: true,
                  message: 'メールアドレスは必須です。',
                },
              ],
              initialValue: order.email,
            })(
              <Input
                onChange={(e) => updateOrderField({ email: e.target.value })}
              />
            )}
          </Form.Item>
          <PaymentCard
            store={store}
            order={order}
            updateOrderField={updateOrderField}
            getFieldDecorator={getFieldDecorator}
          />
          <Form.Item {...styleFormItem} label="お受け取り希望日">
            {getFieldDecorator('shipDate', {
              rules: [
                {
                  type: 'object',
                  required: true,
                  message: 'お受け取り希望日を選択してください。',
                },
              ],
              initialValue: order.shipDate,
            })(
              <DatePicker
                onChange={this.updateShipDate}
                format='YYYY/MM/DD'
                locale={locale}
                disabledDate={this.disableDate}
              />
            )}
          </Form.Item>
          <Form.Item
            {...styleFormItem}
            label="お受け取り希望時間"
            validateStatus={!this.state.validShipDate ? 'error' : ''}
            help={this.state.validShipDateMsg}
          >
            {getFieldDecorator('shipDateTime', {
              rules: [
                {
                  type: 'object',
                  required: true,
                  message: 'お受け取り時間を入力してください。',
                },
              ],
              initialValue: order.shipDate,
            })(
              <TimePicker
                onChange={this.updateShipDateTime}
                format='HH:mm'
                minuteStep={5}
                locale={localeTimepicker}
                disabledHours={this.disableHours}
                disabledMinutes={this.disableMinutes}
              />
            )}
          </Form.Item>
          <Form.Item {...styleFormItem} label="備考">
            {getFieldDecorator('note', {
              initialValue: order.note,
            })(
              <TextArea
                onChange={(e) => updateOrderField({ note: e.target.value })}
                placeholder="ご要望がございましたらこちらにご記入ください。例）たまごアレルギーのためマヨネーズ抜きでお願いします"
                rows={4}
              />
            )}
          </Form.Item>

          <Form.Item {...tailFormItemLayout}>
            <Button
              type="primary"
              htmlType="submit"
              loading={this.props.isSaving}
            >
              確認画面へ
            </Button>
          </Form.Item>
        </Form>
      </Fragment>
    );
  }

  private updateShipDateTime(time: moment.Moment) {
    const { order } = this.props;
    const newShipDate = order.shipDate ? order.shipDate : moment();

    if (time) {
      newShipDate.hour(time.hours());
      newShipDate.minute(time.minutes());
      this.props.updateOrderField({ shipDate: newShipDate });
    }
  }

  private updateShipDate(selectedDate: moment.Moment) {
    const { order } = this.props;
    const newShipDate = order.shipDate ? order.shipDate : moment();
    this.disableSubmit();

    if (selectedDate) {
      newShipDate.year(selectedDate.years());
      newShipDate.month(selectedDate.months());
      newShipDate.date(selectedDate.dates());
      this.props.updateOrderField({ shipDate: newShipDate });
    }
  }

  private save(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    try {
      this.props.form.validateFields((err) => {
        if (!err && !this.disableSubmit()) {
          this.props.onClickSave();
        }
      });
    } catch (e) {
      window.console.error(e);
    }
  };

  private disableDate(current: moment.Moment) {
    const { store } = this.props;
    const minDate = store.minOrderDate();
    minDate.set({ hours: 0, minutes: 0, second: 0 });

    return current && current < minDate;
  }

  private disableHours() {
    const { store } = this.props;
    const openTime: string | undefined = store.businessOpenTime && store.businessOpenTime.format('HH:mm');
    const closeTime: string | undefined = store.businessCloseTime && store.businessCloseTime.format('HH:mm');
    const openTimes = openTime && openTime.split(':');
    const closeTimes = closeTime && closeTime.split(':');
    let times:number[] = [];

    if (openTimes) {
      for (let step = parseInt(openTimes[0]) - 1; step >= 0; step--) {
        times.push(step);
      }
    }

    if (closeTimes) {
      for (let step = parseInt(closeTimes[0]) + 1; step <= 23; step++) {
        times.push(step);
      }
    }

    return times;
  }

  private disableMinutes(hour: number) {
    const { store } = this.props;
    const openTime: string | undefined = store.businessOpenTime && store.businessOpenTime.format('HH:mm');
    const closeTime: string | undefined = store.businessCloseTime && store.businessCloseTime.format('HH:mm');
    const openTimes = openTime && openTime.split(':');
    const closeTimes = closeTime && closeTime.split(':');
    let times:number[] = [];

    if (openTimes && parseInt(openTimes[0]) === hour) {
      for (let step = parseInt(openTimes[1]) - 1; step >= 0; step--) {
        times.push(step);
      }
    }

    if (closeTimes && parseInt(closeTimes[0]) === hour) {
      for (let step = parseInt(closeTimes[1]) + 1; step <= 59; step++) {
        times.push(step);
      }
    }

    return times;
  }

  private disableSubmit() {
    const { order, store } = this.props;
    const valid = validShipDate(store, order);

    if (valid.result) {
      this.setState({ validShipDate: true });
      this.setState({ validShipDateMsg: null });
    } else if (this.state.validShipDateMsg !== valid.msg) {
      this.setState({ validShipDate: false });
      this.setState({ validShipDateMsg: valid.msg || null });
    }

    return !valid.result;
  }
}

export default Form.create<Props & FormComponentProps>()(PaymentOnlyTakeout);
